import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { plansService } from '@/features/plans';

export function useAssignablePlansQuery(enabled: boolean) {
  const filters = { page: 1, limit: 100, isActive: true, assignableOnly: true };
  return useQuery({ queryKey: queryKeys.plans.list(filters), queryFn: () => plansService.list(filters), enabled });
}
